import React, { useState, useEffect } from "react";
import "./ReleaseBanner.css";

const ReleaseBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the banner for this release
    const dismissed = localStorage.getItem("relayReleaseBannerDismissed_v2.0");
    if (!dismissed) {
      // Add a small delay for the "nudge" effect to slide in after page load
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("relayReleaseBannerDismissed_v2.0", "true");
  };

  if (!isVisible) return null;

  return (
    <div className="release-banner-nudge">
      <div className="release-banner-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
        </svg>
      </div>
      <div className="release-banner-content">
        <h4>New Release Available!</h4>
        <p>Experience the new and improved platform features.</p>
      </div>
      <button className="release-banner-close" onClick={handleDismiss} aria-label="Dismiss">
        &times;
      </button>
    </div>
  );
};

export default ReleaseBanner;
